<template>
  <ul>
    <li v-if="showDebug">
      <div
        v-for="(item, key) in viewColumn"
        :key="key"
      >
        <span style="font-weight: 500">{{ key }}:</span> {{ item }}
      </div>
    </li>
    <!--SORT UP-->
    <li @click="tableStore.setSorting({ columnName: viewColumn.field,  order: 'ASC' })">
      <font-awesome-icon :icon="['fal', 'arrow-down-a-z']" class="menuitem-icon" />
      <span>Sorter stigende</span>
    </li>
    <!--SORT DOWN-->
    <li @click="tableStore.setSorting({ columnName: viewColumn.field,  order: 'DESC' })">
      <font-awesome-icon :icon="['fal', 'arrow-down-z-a']" class="menuitem-icon" />
      <span>Sorter synkende</span>
    </li>
    <li class="separator" />
    <!--INPUT-->
    <li>
      <div class="checkbox-container">
        <BaseCheckbox
          v-for="option in options"
          :key="option.value"
          :label="option.label"
          :model-value="inputValue[option.value]"
          @update:modelValue="(value) => handleCheckboxChange(option.value, value)"
        />
      </div>
    </li>

    <!--REMOVE FILTERS-->
    <li @click="clearFilter()">
      <font-awesome-icon :icon="['fal', 'filter-slash']" class="menuitem-icon remove" />
      <span>Fjern alle filter</span>
    </li>
    <li class="separator" />
    <!--REFRESH-->
    <li @click="() => { tableStore.refreshQuery(); $emit('close') }">
      <font-awesome-icon :icon="['fal', 'play']" class="menuitem-icon play" />
      <span>Oppdater</span>
    </li>
  </ul>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useTableStore } from '@/store/storeTable'
import { useGlobalStore } from '@/store/storeGlobal'
import BaseCheckbox from '@/components/BaseComponents/BaseCheckbox.vue'

// GlobalStore
const globalStore = useGlobalStore()
const { showDebug } = storeToRefs(globalStore)

const props = defineProps({
  viewColumn: { type: Object, required: true }
})

const tableStore = useTableStore()
const { whereItems } = storeToRefs(tableStore)

const inputValue = ref({})


const options = computed(() => {
  const baseOptions = [
    { label: 'Ja', value: '1' },
    { label: 'Nei', value: '0' }
  ]

  // Legg til "Ukjent" kun hvis isNullable er true
  if (props.viewColumn.isNullable) {
    baseOptions.push({ label: 'Ukjent', value: 'null' })
  }

  return baseOptions
})

// Synkroniser med eksisterende filtre
watch(() => whereItems.value, () => {
  const existingFilter = whereItems.value.find(item =>
    item.columnName === props.viewColumn.field && item.operator === 'in'
  )

  options.value.forEach(option => {
    inputValue.value[option.value] = existingFilter
      ? existingFilter.value.includes(option.value)
      : false
  })
}, { immediate: true })

function handleCheckboxChange (value, checked) {
  inputValue.value[value] = checked
  updateFilters()
}

function updateFilters () {
  const selectedItems = Object.entries(inputValue.value)
    .filter(([, isSelected]) => isSelected)
    .map(([value]) => value)

  if (selectedItems.length > 0) {
    tableStore.addFilterActionOperator(props.viewColumn.field, 'in', selectedItems)
  } else {
    tableStore.clearFilter(props.viewColumn.field)
  }
}

function clearFilter () {
  tableStore.clearFilter(props.viewColumn.field)
  inputValue.value = {}
}


</script>

<style scoped>
ul {
  list-style-type: none;
  padding-inline-start: 0;
  margin: 0;
}

li {
  cursor: pointer;
  padding: 12px;
}

li:hover {
  background-color: rgb(241, 241, 241);
}

.separator {
  border-top: 1px solid silver;
  padding: 0;
}

.menuitem-icon {
  margin-right: 12px;
}

.play {
  color: #689f38;
}

.remove {
  color: #d32f2f;
}

.filter-item {
  display: inline-block;
  width: 11.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.checkbox-container {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
